import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
} from "ng-apexcharts";
import { Component, OnInit, Input, ViewChild, SimpleChange } from '@angular/core';


export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
};

@Component({
  selector: 'app-vew-line-chart',
  templateUrl: './vew-line-chart.component.html',
  styleUrls: ['./vew-line-chart.component.scss']
})
export class VewlineChartComponent implements OnInit {

  _objectGraphic:any;
  validator:boolean = false;
  valor:any;
  @ViewChild("chart") chart: ChartComponent;
  public newObject: Partial<ChartOptions>;

  @Input() set objectGraphic(value: any) {
    this.validator = this.getValidator(value);
    let argCopy: any = Object.assign({}, value);
    this.newObject = null;
    this.newObject = null;
    this._objectGraphic = argCopy;
    this.newObject = argCopy;
    // this.newObject.legend = Object.assign ({}, value.legend);
    console.log('en el view line', value)
    this.valor = value;
  }

  get objectGraphic(): any {
    return this._objectGraphic;
  }
  constructor() {
    this.validator = this.getValidator(this.objectGraphic);
    this.newObject = this.objectGraphic;
   }

  ngOnInit() {
    this.validator = this.getValidator(this.objectGraphic);
    this.newObject = this.objectGraphic;
  }

  getValidator(value){
    if(value === null || value === undefined){
      return false;
    }else{
      return true;
    }
  }

}
